import { createSlice } from "@reduxjs/toolkit";

const pricingPromotionSlice = createSlice({
  name: "pricing_promotion",
  initialState: {
    pricing_promotion: null,
    error: false,
    errorMessage: "",
  },
  reducers: {
    getPricingPromotionSuccess: (state, action) => {
      state.pricingPromotionList = action.payload;
    }
  },
  selectors: {
    getAllPricingPromotions: (state) => state.pricingPromotionList ?? []
  }
});

export const { getPricingPromotionSuccess } = pricingPromotionSlice.actions;

export const { getAllPricingPromotions } = pricingPromotionSlice.selectors;

export default pricingPromotionSlice.reducer;
